<template>
    <div class="p-relative">

       <div class="wrapperForm dashboardWrapper">
            <v-row dense>
                <v-col cols="12" sm="12" md="4" class="section-wrapper group-color-widj">
                    
                    <v-card class="mdwi-gr-blue colorWdj cursor-pointer" flat @click="onInWorkStatusClick('All')">
                        <v-card-text v-if="false">
                            <v-skeleton-loader
                                class="mx-auto"
                                max-height="102"
                                min-height="102"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>

                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mdwi-text-box">
                                <div class="mdwi-count">
                                    {{ myOrdersOnExecutionCounter }}
                                    <span v-if="myOrdersOnExecutionUnreadedCounter > 0">(+{{ myOrdersOnExecutionUnreadedCounter }})</span>
                                </div>
                            </div>
                            <div class="mdwi-title-box">{{$t('На_исполнении')}}</div>
                            <div class="mdwi-progress-panel">
                                <div class="mdwi-progress-bar"></div>
                            </div>
                            <div class="mdwi-description-panel">{{$t('На_исполнении_виджет_описание')}}</div>
                        </v-card-text>
                    </v-card>

                    <v-card class="mdwi-gr-red colorWdj cursor-pointer" flat @click="onInWorkStatusClick('Expired')">
                        <v-card-text v-if="false">
                            <v-skeleton-loader
                                class="mx-auto"
                                max-height="102"
                                min-height="102"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>

                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mdwi-text-box">
                                <div class="mdwi-count">
                                    {{ myOverdueCounter }}
                                    <span v-if="false">(+0)</span>
                                </div>
                            </div>
                            <div class="mdwi-title-box">{{$t('В_том_числе_просроченные')}}</div>
                            <div class="mdwi-progress-panel">
                                <div class="mdwi-progress-bar"></div>
                            </div>
                            <div class="mdwi-description-panel">{{$t('Просроченные_виджет_описание')}}</div>
                        </v-card-text>
                    </v-card>

                    <v-card class="mdwi-gr-aqua colorWdj cursor-pointer" flat>
                        <v-card-text v-if="false">
                            <v-skeleton-loader
                                class="mx-auto"
                                max-height="102"
                                min-height="102"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>

                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mdwi-text-box">
                                <div class="mdwi-count">
                                    0
                                    <span v-if="false">(+0)</span>
                                </div>
                            </div>
                            <div class="mdwi-title-box">{{$t('На_доработке')}}</div>
                            <div class="mdwi-progress-panel">
                                <div class="mdwi-progress-bar"></div>
                            </div>
                            <div class="mdwi-description-panel">{{$t('На_доработке_виджет_описание')}}</div>
                        </v-card-text>
                    </v-card>

                    <v-card class="mdwi-gr-green colorWdj cursor-pointer" flat @click="onInExecutedStatusClick">
                        <v-card-text v-if="false">
                            <v-skeleton-loader
                                class="mx-auto"
                                max-height="102"
                                min-height="102"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>

                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mdwi-text-box">
                                <div class="mdwi-count">
                                    {{ myOrdersOnCheckCounter }}
                                    <span v-if="false">(+0)</span>
                                </div>
                            </div>
                            <div class="mdwi-title-box">{{$t('Выполнено')}}</div>
                            <div class="mdwi-progress-panel">
                                <div class="mdwi-progress-bar"></div>
                            </div>
                            <div class="mdwi-description-panel">{{$t('Исполненные_документы')}}</div>
                        </v-card-text>
                    </v-card>

                    <!--
                    <v-card class="mdwi-gr-orange colorWdj cursor-pointer" flat>
                        <v-card-text v-if="false">
                            <v-skeleton-loader
                                class="mx-auto"
                                max-height="102"
                                min-height="102"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>

                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mdwi-text-box">
                                <div class="mdwi-count">
                                    0
                                    <span v-if="true">(+0)</span>
                                </div>
                            </div>
                            <div class="mdwi-title-box">{{$t('На_согласовании')}}</div>
                            <div class="mdwi-progress-panel">
                                <div class="mdwi-progress-bar"></div>
                            </div>
                            <div class="mdwi-description-panel">{{$t('На_согласовании_виджет_описание')}}</div>
                        </v-card-text>
                    </v-card>

                    <v-card class="mdwi-gr-purple colorWdj cursor-pointer" flat>
                        <v-card-text v-if="false">
                            <v-skeleton-loader
                                class="mx-auto"
                                max-height="102"
                                min-height="102"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>

                        </v-card-text>
                        <v-card-text v-else>
                            <div class="mdwi-text-box">
                                <div class="mdwi-count">
                                    0
                                    <span v-if="true">(+0)</span>
                                </div>
                            </div>
                            <div class="mdwi-title-box">{{$t('В_работе')}}</div>
                            <div class="mdwi-progress-panel">
                                <div class="mdwi-progress-bar"></div>
                            </div>
                            <div class="mdwi-description-panel">{{$t('В_работе_виджет_описание')}}</div>
                        </v-card-text>
                    </v-card>
                    -->
                </v-col>

                <v-col cols="12" sm="12" md="4" class="section-wrapper">
                    <v-card flat>
                        
                        <v-card-text>
                            <div class="form-box-title">{{ $t("Мои_поручения") }}</div>
                            <v-skeleton-loader
                                v-if="ompDataSourceLoading"
                                class="mx-auto"
                                max-height="330"
                                min-height="330"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>
                            <template v-if="onMyPerformanceSeries.series.length">
                                <!--<RingChart
                                    class="chartBox"
                                    typeChart="pie"
                                    :series="onMyPerformanceSeries" 
                                    :labels="onMyPerformanceLabels" 
                                    :colors="onMyPerformanceColors"    
                                    :click="onMyPerformanceClick"
                                    :showLabel="false"
                                    heightChart="330"                              
                                />-->
                                <RingChartjs
                                    typeChart="donut"
                                    :series="onMyPerformanceSeries" 
                                    :labels="onMyPerformanceLabels" 
                                    :colors="onMyPerformanceColors"    
                                    :click="onMyPerformanceClick"
                                    :showTotal="true"
                                    heightChart="330px"                              
                                />
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12" sm="12" md="4" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title title-with-right-part">
                                <span>{{ $t("Исполнительская_дисциплина") }}</span>
                                <div class="twrp-content twrp-content-filter-p">
                                    <v-select
                                        v-model="performingDisciplineGraphView"
                                        :items="performingDisciplineList"
                                        item-text="view"
                                        item-value="id"
                                        hide-details
                                        outlined
                                        dense
                                        append-icon="fas fa-chevron-down"
                                        class="autocomplete-chip autocomplete-chip-22"
                                        :menu-props="{ bottom: true, offsetY: true }"
                                        style="width:135px;"
                                    >
                                    </v-select>
                                </div>
                            </div>
                            <v-skeleton-loader
                                v-if="eqDataSourceLoading"
                                class="mx-auto"
                                max-height="330"
                                min-height="330"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>
                            <template v-if="performingDisciplineSeries.series.length && performingDisciplineGraphView == 0">
                                <RingChartjs
                                    typeChart="donut"
                                    :series="performingDisciplineSeries" 
                                    :labels="[ $t('Исполнено')]" 
                                    :colors="performingDisciplineColors"
                                    :click="performingDisciplineClick"
                                    heightChart="330px"
                                    :showLabels="false"
                                    :showLegend="false"
                                    :showToolTips="false"
                                    :centerText="getPerformingDisciplineText"
                                />
                            </template>
                            <template v-else-if="performingDisciplineBar.series.length && performingDisciplineGraphView == 1">
                                <BarColumnRotateLabelChartjs
                                    :datasource="performingDisciplineBar"
                                    :plotOptionsBarDistributed="true"
                                    :dataValuesWithPercentSymbol="true"
                                    :dataLabelsPercentValues="true"
                                    height="330px"
                                    columnWidth="15%"
                                />
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
                
            </v-row>

            <v-row dense>

                <v-col cols="12" sm="12" md="4" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title">{{ $t("Поручения_с_нарушением_срока_исполнения") }}</div>
                            <v-skeleton-loader
                                v-if="osDataSourceLoading"
                                class="mx-auto"
                                max-height="330"
                                min-height="330"
                                type="image, list-item-avatar-three-line"
                            ></v-skeleton-loader>
                            <template v-if="tasksWithViolatedDeadlinesSeries.series.length">
                                <!--<RingChart
                                    class="chartBox"
                                    typeChart="pie"
                                    :series="tasksWithViolatedDeadlinesSeries" 
                                    :labels="tasksWithViolatedDeadlinesLabels" 
                                    :colors="tasksWithViolatedDeadlinesColors"    
                                    :click="tasksWithViolatedDeadlinesClick"
                                    :showLabel="false"
                                    heightChart="330"                            
                                />-->
                                <RingChartjs
                                    typeChart="pie"
                                    :series="tasksWithViolatedDeadlinesSeries" 
                                    :labels="tasksWithViolatedDeadlinesLabels" 
                                    :colors="tasksWithViolatedDeadlinesColors"    
                                    :click="tasksWithViolatedDeadlinesClick"
                                    :showTotal="false"
                                    heightChart="330px"                            
                                />
                            </template>
                        </v-card-text>
                    </v-card>
                </v-col>
                
                <v-col cols="12" sm="12" md="8" class="section-wrapper">
                    <v-card flat>
                        <v-card-text>
                            <div class="form-box-title">{{ $t("Исполнительская_дисциплина") }}</div>
                            <div class="group-chart-vidget">
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="eqaDataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <template v-if="performingDisciplineByAuthorSeries.series.length">
                                        <!--<RingChart
                                            class="chartBox"
                                            typeChart="radialBar"
                                            :series="performingDisciplineByAuthorSeries" 
                                            :labels="[ $t('Исполнено')]" 
                                            :colors="performingDisciplineByAuthorColors"
                                            :click="performingDisciplineByAuthorClick"
                                            heightChart="306"
                                            style="height:306px;"
                                        />-->
                                        <RingChartjs
                                            typeChart="donut"
                                            :series="performingDisciplineByAuthorSeries" 
                                            :labels="[ $t('Исполнено')]" 
                                            :colors="performingDisciplineByAuthorColors"
                                            :click="performingDisciplineByAuthorClick"
                                            heightChart="298px"
                                            :showLabels="false"
                                            :showLegend="false"
                                            :showToolTips="false"
                                            :centerText="getPerformingDisciplineByAuthorText"
                                        />
                                        <div class="d-flex justify-center mt-2">
                                            <v-btn
                                                small
                                                depressed
                                                color="teal"
                                                class="text-capitalize white--text"
                                                @click="performingDisciplineByAuthorReportClick"
                                            >
                                                {{$t("Сформировать_отчет")}}
                                            </v-btn>
                                        </div>
                                    </template>
                                </div>
                                <div class="gcv-col">
                                    <v-skeleton-loader
                                        v-if="eqaDataSourceLoading"
                                        class="mx-auto"
                                        max-height="330"
                                        min-height="330"
                                        type="image, list-item-avatar-three-line"
                                    ></v-skeleton-loader>
                                    <div 
                                        v-if="executionOfEmployeesData && executionOfEmployeesData.length"
                                        class="overflow-y-auto overflow-x-hidden" 
                                        style="height:330px;"
                                    >
                                        <!--<BarChartStack
                                            class="chartBox"
                                            :datasource="executionOfEmployeesData" 
                                            :categories="executionOfEmployeesLabels"
                                            :click="executionOfEmployeesClick"
                                            :height="executionOfEmployeesChartHeight()"
                                            :xaxisMax="100"
                                        />-->
                                        <BarChartjsStack
                                            :datasource="executionOfEmployeesData" 
                                            :categories="executionOfEmployeesLabels"
                                            :click="executionOfEmployeesClick"
                                            :heightChart="executionOfEmployeesChartHeight()"
                                            :barThickness="barThickness"
                                        />
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                
            </v-row>

       </div>

    </div>
</template>

<script>
import { httpAPI } from "@/api/httpAPI";
//import _ from 'lodash';
//import sys from '@/services/system';
import { mapGetters, mapMutations, mapActions} from 'vuex';
//import RingChart from '@/components/apexcharts/ringChart';
//import BarChartStack from '@/components/apexcharts/barChartStack';
//import BarColumnRotateLabelChart from '@/components/apexcharts/barColumnRotateLabelChart';

//chartjs
import RingChartjs from '@/components/chartjs/ringChart';
import BarColumnRotateLabelChartjs from '@/components/chartjs/barColumnRotateLabelChart';
import BarChartjsStack from '@/components/chartjs/barChartStack';

export default {
    name: "MyOrdersDashboard",
    components: {
        //RingChart,
        //BarChartStack,
        //BarColumnRotateLabelChart,
        RingChartjs,
        BarColumnRotateLabelChartjs,
        BarChartjsStack
    },
    
    data: () => {
        return {
            eqDataSource: null,
            eqDataSourceLoading: true,
            osDataSource: null,
            osDataSourceLoading: true,
            ompDataSource: null,
            ompDataSourceLoading: true,
            eqaDataSource: null,
            eqaDataSourceLoading: true,
            barThickness : 30,
            barGap: 5,
            totalLabel: "%",
            dataSourceLoading: true,
            
            onMyPerformanceColors: [
                '#43B581',
                '#FAA61A',
                '#f57731',
                '#f04747'
            ],

            performingDisciplineColorRanges: [
                { start: 0, end: 29, color: '#f04747' },
                { start: 30, end: 49, color: '#f57731' },
                { start: 50, end: 74, color: '#FAA61A' },
                { start: 75, end: 100, color: '#43B581' },
            ],

            tasksWithViolatedDeadlinesColors: [
                '#43B581',
                '#f57731',
                '#9B84EE',
                '#FAA61A'
            ],

            performingDisciplineGraphView: 0,
            
        }
    },
    computed: {
        ...mapGetters('global/auth', ['getUserInfo']),
        ...mapGetters('documents/references', { months: 'GetMonths'}),
        ...mapGetters('orders', {
            isCountersLoading: 'isCountersLoading',
            //На исполнении
            myOrdersOnExecutionCounter: 'getMyOrdersOnExecutionCounter',
            //На исполнении не прочтенные
            myOrdersOnExecutionUnreadedCounter: 'getMyOrdersOnExecutionUnreadedCounter',
            //Выполнено
            myOrdersOnCheckCounter: 'getMyOrdersOnCheckCounter',
            

        }),
        curMonth() {
            return new Date().getMonth() + 1;
        },
        onMyPerformanceLabels() {
            return [
                this.$t('Срок_более_10_дней'),
                this.$t('Срок_менее_10_дней'),
                this.$t('Срок_сегодня'),
                this.$t('Просрочено')
            ]
        },
        tasksWithViolatedDeadlinesLabels() {
            return [
                this.$t('На_рассмотрении_документа'),
                this.$t('На_исполнеии_порученния'),
                this.$t('На_проверке_исполнения'),
                this.$t('На_снятии_с_контроля')
            ]
        },
        myOverdueCounter() {
            return this.ompDataSource?.find(e => e.status == 'OverDue')?.count ?? 0;
        },
        onMyPerformanceSeries() {

            if (this.ompDataSource && this.ompDataSource.length > 0) {
                let sourceData = [
                    this.ompDataSource.find(e => e.status == 'ControlOver10Days')?.count ?? 0, //Более 10 дней
                    this.ompDataSource.find(e => e.status == 'ControlLess10Days')?.count ?? 0, //Менее 10 дней
                    this.ompDataSource.find(e => e.status == 'ControlTonight')?.count ?? 0, //Сегодня
                    this.ompDataSource.find(e => e.status == 'OverDue')?.count ?? 0, //Просрочено
                ]; 

                let coef = 100 / (sourceData.reduce((a, b) => a + b, 0));

                return {
                    series: sourceData.map((value) => {
                        let percentageValue = Math.round(coef * (value));
                        return percentageValue > 0 && percentageValue < this.minPercent ? this.minPercent : percentageValue;
                    }),
                    values: sourceData                        
                };
            }

            return {
                series: [],
                values: []
            };
        },
        performingDisciplineList() { 
            return [
                { id: 0, view: this.$t('За_период') },
                { id: 1, view: this.$t('По_месяцам') },
            ]
        },
        performingDisciplineSeries() {
            if (this.eqDataSource) {
                if (this.eqDataSource.length == 0){
                    return {
                            series: [],
                            values: []
                        };
                }
                else {
                    const result = this.eqDataSource.reduce((acc, obj) => {
                        for (const key in obj) {
                            if (typeof obj[key] === 'number') {      // <-- суммируем только числа
                            acc[key] = (acc[key] || 0) + obj[key];
                            }
                        }
                        return acc;
                        }, {});

                        let r = Math.round(((result.executed * 1 + result.executedoverdue * 0.5)/(result.total)) * 100);
                        return {
                            series: [r, 100 - r],
                            values: [r + '%']
                        };
                }
            }
            
            return {
                series: [],
                values: []
            };
        },
        performingDisciplineColors() {

            if (this.performingDisciplineSeries) {
                let r = this.performingDisciplineSeries.series[0];
                
                let resultColor = this.performingDisciplineColorRanges.find(e => r >= e.start && r <= e.end);
                return resultColor ? [resultColor.color, 'transparent'] : ['#43B581', 'transparent']; 
            }
            
            return ['#43B581', 'transparent'];
        },
        getPerformingDisciplineText(){
            const value = this.performingDisciplineSeries?.series[0];
            if (value)
                return [`${value}%`];
            return '';
        },
        performingDisciplineBar() {
            if (this.eqDataSource){
                let data = [];
                let categories = [];
                let colors = [];
                for (let i = this.curMonth - 2; i <= this.curMonth; i++){
                    let monNum = i < 1 ? 12 + i : i;
                    const monthData = this.eqDataSource.find(d => d.month_number == monNum);
                    const monthName = this.months.find(m => m.id == monNum)?.name ?? "";
                    categories.push(this.$t(monthName));
                    if (monthData && monthData.total > 0) {
                        const v = Math.round(((monthData.executed * 1 + monthData.executedoverdue * 0.5)/(monthData.total)) * 100)
                        data.push(v);
                        let resultColor = this.performingDisciplineColorRanges.find(e => v >= e.start && v <= e.end);
                        colors.push(resultColor ? resultColor.color : '#43B581'); 
                    }   
                    else {
                        data.push(null);
                        colors.push("#43B581");
                    }
                }
                console.log(data, categories, colors);
                return { series: [{ data }], categories, colors };
            }

            return {
                series: [],
                categories: []
            }
        },
        tasksWithViolatedDeadlinesSeries() {

            if (this.osDataSource) {

                let sourceData = [
                    this.osDataSource.oninspect, 
                    this.osDataSource.overdue, 
                    this.osDataSource.oncheckexecution,
                    this.osDataSource.ontakeoffcontrol, 
                ]; 

                let coef = 100 / (sourceData.reduce((a, b) => a + b, 0));

                return {
                    series: sourceData.map((value) => {
                        let percentageValue = Math.round(coef * (value));
                        return percentageValue > 0 && percentageValue < this.minPercent ? this.minPercent : percentageValue;
                    }),
                    values: sourceData                        
                };
                
            }

            return {
                series: [],
                values: []
            };
        },
        performingDisciplineByAuthorSeries() {

            if (this.eqaDataSource && this.eqaDataSource.length > 0) {
                
                const v = this.eqaDataSource.reduce((acc, obj) => {
                        for (const key in obj) {
                            if (typeof obj[key] === 'number') {      // <-- суммируем только числа
                            acc[key] = (acc[key] || 0) + obj[key];
                            }
                        }
                        return acc;
                    }, {});

                //let r = Math.round(((v.takeoff + v.takeoffoverdue * 0.3 + v.executed * 0.7 + v.executedoverdue * 0.2)/(v.takeoff + v.takeoffoverdue + v.overdue + v.executed + v.executedoverdue)) * 100);
                if (v.total != 0){
                    const r = v.total == 0 ? 0 : Math.round(((v.executed + v.executedoverdue * 0.5)/(v.total)) * 100);
                    return {
                        series: [r, 100 - r],
                        values: [r + '%']
                    };
                }
            }

            return {
                series: [],
                values: []
            };
        },
        performingDisciplineByAuthorColors() {

            if (this.performingDisciplineByAuthorSeries) {
                let r = this.performingDisciplineByAuthorSeries.series[0];
                let colorsData = [
                    { start: 0, end: 29, color: '#f04747' },
                    { start: 30, end: 49, color: '#f57731' },
                    { start: 50, end: 74, color: '#FAA61A' },
                    { start: 75, end: 100, color: '#43B581' },
                ];
                
                let resultColor = colorsData.find(e => r >= e.start && r <= e.end);
                return resultColor ? [resultColor.color, 'transparent'] : ['#43B581', 'transparent']; 
            }
            
            return ['#43B581', 'transparent'];
        },
        getPerformingDisciplineByAuthorText(){
            const value = this.performingDisciplineByAuthorSeries?.series[0];
            if (value)
                return [`${value}%`];
            return '';
        },
        minPercent() {
            return 4;
        },
        fontSize() {
            return 20;
        },
        executionOfEmployeesSortedSourceData() {

           if (this.eqaDataSource && this.eqaDataSource.length > 0) {

                /*return this.eqaDataSource.reduce((a,e) => {

                    if (e.executedoverdue || e.executed) {
                       a.push(e);
                    }

                    return a;

                }, []).sort((a, b) => {
                    
                    const sumA = a.executedoverdue + a.executed;
                    const sumB = b.executedoverdue + b.executed;
                    
                    return sumA - sumB;

                });*/
                return Object.values(
                    this.eqaDataSource.reduce((acc, obj) => {
                        const executerid = obj.executerid;
                        // Если объекта с таким id ещё нет — создаём копию, но все числовые поля обнулим
                        let executerCounts = acc.find(a => a.executerid == executerid); 
                        if (!executerCounts) {
                            executerCounts = { executerid, executername: obj.executername};
                            acc.push(executerCounts);
                        }

                        for (const key in obj) {
                            const value = obj[key];

                            if (typeof value === "number" && key !== "id") {
                                executerCounts[key] = (executerCounts[key] || 0) + value;
                            }
                        }

                        return acc;
                    }, []).sort((a, b) => {
                        const sumA = a.executedoverdue + a.executed;
                        const sumB = b.executedoverdue + b.executed;
                        return sumA - sumB;
                    })
                );
            }

            return [];
                
        },
        executionOfEmployeesData() {
            if (this.executionOfEmployeesSortedSourceData && this.executionOfEmployeesSortedSourceData.length > 0) {
                
                let sourceData = this.executionOfEmployeesSortedSourceData.reduce((a, e) => {

                    a.push([e.executedoverdue, e.executed]) 

                    return a;
                }, []);

                if (!sourceData.length)
                    return []; 

                let rotateClockwise = function (matrix) {
                    return matrix[0].map((val, index) => matrix.map(row => row[index]).reverse());
                };

                // let rotateCounterClockwise = function (matrix) {
                //     return matrix[0].map((val, index) => matrix.map(row => row[index])).reverse();                        
                // };
                
                let coef = 100 / Math.max.apply(null, sourceData.map((data) => data.map(v => v).reduce((a, v) => a + v, 0)));
                
                sourceData = rotateClockwise(sourceData);

                let percentageData = sourceData.map((data) => data.map(v => {
                    let percentageValue = Math.round(coef * (v));
                    return percentageValue > 0 && percentageValue < this.minPercent ? this.minPercent : percentageValue;
                }));
                
                let correctedData = sourceData.map((data) => data.map(v => {
                    return (v == 0 ? "" : v);
                }));

                let result = percentageData.map((data, index) => {

                    let item = {
                        name: '',
                        data: data,
                        color: '#',
                        datalabels: {
                            formatter: function (value, context){ return correctedData[context.datasetIndex][context.dataIndex]; },
                            font: { size: this.fontSize }
                        },
                        value: sourceData[index]
                    };

                    switch (index) {
                        case 0:
                            item.name = this.$t("Исполнено_с_нарушением_срока");
                            item.color = '#F04747';
                            break;

                        case 1:
                            item.name = this.$t("Исполнено_в_срок");
                            item.color = '#43B581';
                            break;

                        default:
                            break;
                    }

                    return item;
                });

                console.log('result', result);

                return result;
            }

            return [];
        },
        executionOfEmployeesLabels() {

            if (this.executionOfEmployeesSortedSourceData && this.executionOfEmployeesSortedSourceData.length > 0) {

                return this.executionOfEmployeesSortedSourceData.reduce((a, e) => {

                    a.push(e.executername);

                    return a;
                }, []).reverse();

            }

            return [];
        }
    },
    methods: {
        ...mapMutations('orders/lists/myordersonexecution', { setExecutionStatus: 'SET_TERM', setOrderType: 'SET_STATUS' }),
        ...mapActions('orders', ['updateCounter']),
        async initialize() {
            this.updateCounter();
            this.dataSourceLoading = true;      

            //this.getData({ type: 'execution-quality', fromDate: '2023-01-01'})
            this.getData({ 
                type: 'execution-quality', 
                executerId: this.getUserInfo.WorkplaceId, 
                fromDate: `/Date(${ Date.parse(this.$moment().add(-2, 'month').startOf('month').format('YYYY-MM-DD'))})/`, 
                currentDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/`,  
                toDate: `/Date(${ Date.parse(this.$moment().endOf('month').format('YYYY-MM-DD'))})/`}) 
            .then(response => {
                this.eqDataSource = response ? response.data.Payload : null;
                this.eqDataSourceLoading = false;
            });

            this.getData({ type: 'on-my-performance'})
            .then(response => {
                this.ompDataSource = response ? response.data.Payload : null;
                this.ompDataSourceLoading = false;
            });


            this.getData({ 
                type: 'overdue-statistic', 
                authorId: this.getUserInfo.WorkplaceId, 
                fromDate: `/Date(${ Date.parse('2023-01-01')})/`, 
                currentDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/`, 
                toDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/` })
            .then(response => {
                this.osDataSource = response ? response.data.Payload : null;
                this.osDataSourceLoading = false;
            });


            this.getData({
                type: 'execution-quality', 
                authorId: this.getUserInfo.WorkplaceId, 
                fromDate: `/Date(${ Date.parse(this.$moment().add(-2, 'month').startOf('month').format('YYYY-MM-DD'))})/`, 
                currentDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/`,  
                toDate: `/Date(${ Date.parse(this.$moment().endOf('month').format('YYYY-MM-DD'))})/`}) 
            .then(response => {
                this.eqaDataSource = response ? response.data.Payload : null;
                this.eqaDataSourceLoading = false;
            });

            this.dataSourceLoading = false;
        },
        async getData(params) {

            if (params.type == 'overdue-statistic' || params.type == 'execution-quality')
                return await httpAPI({
                    url: `api/orders/report?type=${params.type}`,
                    method: 'POST',
                    headers: { 'isCommon': true },
                    data: { Content: JSON.stringify(params) }
                });

            return await httpAPI({
                url: `api/orders/counter_inwork`,
                method: 'GET',
                headers: { 'isCommon': true }
            });
        },
        performingDisciplineClick(event, chartContext, config) {
            console.log(event, chartContext, config);
        },
        onMyPerformanceClick(event, chartContext, config) {

            switch (config.dataPointIndex)
            {
                case 0: this.setExecutionStatus('MoreThan10Days'); break;
                case 1: this.setExecutionStatus('LessThan10Days'); break;
                case 2: this.setExecutionStatus('Today'); break;
                case 3: this.setExecutionStatus('Expired'); break;
            }

            this.setOrderType("Order");
            this.$router.push({ path: "orders-on-execution" });   

        },
        tasksWithViolatedDeadlinesClick(event, chartContext, config) {
            console.log(event, chartContext, config);
        },
        performingDisciplineByAuthorClick(event, chartContext, config) {
            console.log(event, chartContext, config);
        },
        performingDisciplineByAuthorReportClick() {
                
            //let exportURI = `api/orders/reportfile?type=execution-quality&filter=${JSON.stringify({ authorId: this.getUserInfo.WorkplaceId, fromDate: '2023-01-01'/*this.$moment().format('YYYY-01-01')*/, currentDate: this.$moment().format('YYYY-MM-DD'), toDate: this.$moment().format('YYYY-MM-DD'), format: 'Xls'})}`;//&token=${this.$store.getters['global/auth/getUserInfo']?.Token}`;
            let exportURI = `api/orders/reportfile?type=execution-quality&filter=${JSON.stringify({
                type: 'execution-quality', 
                authorId: this.getUserInfo.WorkplaceId, 
                fromDate: `/Date(${ Date.parse(this.$moment().add(-2, 'month').startOf('month').format('YYYY-MM-DD'))})/`, 
                currentDate: `/Date(${ Date.parse(this.$moment().format('YYYY-MM-DD'))})/`,  
                toDate: `/Date(${ Date.parse(this.$moment().endOf('month').format('YYYY-MM-DD'))})/`
                , format: 'Xls'})}`;

            let text = this.$i18n.t('Исполнительская_дисциплина');

            this.$eventBus.$emit('on-get-report', {url: exportURI, text: text, type: 'xls' });

        },
        executionOfEmployeesClick(event, chartContext, config) {
            console.log(event, chartContext, config);
        },
        executionOfEmployeesChartHeight(){
            const BAR = this.barThickness || 20;
            const GAP = this.barGap || 10;
            const ROW = BAR + GAP
            return ROW * this.executionOfEmployeesLabels.length;
            /*if(this.executionOfEmployeesLabels.length > 5){
                return 330 + ((this.executionOfEmployeesLabels.length - 6) * 20);
            }else{
                return 330;
            }*/
        },
        onInWorkStatusClick(value) {
            this.setOrderType("All");
            this.setExecutionStatus(value);
            this.$router.push({ name: "MyOrdersOnExecution" });
        },
        onInExecutedStatusClick(){
            this.$router.push({ name: "MyOrdersOnCheck" });
        }
    },
    created() {
        
        this.initialize();
    },
    mounted() {

    },
    beforeDestroy() {

    },
}
</script>